// src/hooks/useHistoryTracking.js (نسخه نهایی و اصلاح شده مسیرها)

import { useEffect, useCallback, useRef } from 'react'; 
import axiosInstance from '../utils/axiosInstance'; 
import { useAuthContext } from '../context/AuthContext'; 

const HEARTBEAT_INTERVAL = 10000; // هر ۱۰ ثانیه

export default function useHistoryTracking(mediaId, currentTime, isPlaying) {

    const lastSentTimeRef = useRef(0);
    const isSendingRef = useRef(false);
    
    const { isLoggedIn } = useAuthContext(); 

    // ----------------------------------------------------
    // الف. تابع ذخیره یکباره بازدید (برای PDF)
    // ----------------------------------------------------
    const trackView = useCallback(async (id) => {
        if (!isLoggedIn || !id) return; 
        
        // ✅ FIX: تغییر مسیر به products (طبق urls.py)
        const endpoint = `/products/user/history/update/`; 
        
        try {
            await axiosInstance.post(endpoint, {
                media_id: id, 
                position_sec: 1, 
            });
            console.log(`[VIEW TRACK] Media ${id} marked as viewed (PDF/Single View).`);
        } catch (error) {
            console.error("Error tracking single view:", error);
        }
    }, [isLoggedIn]); 

    
    // ----------------------------------------------------
    // ب. منطق Heartbeat (برای صوت و ویدیو)
    // ----------------------------------------------------
    const savePlaybackPosition = useCallback(async (id, time) => {
        if (!isLoggedIn || isSendingRef.current || !id || time === 0) return; 
        
        // ✅ FIX: تغییر مسیر به products (طبق urls.py)
        const endpoint = `/products/user/history/update/`; 
        
        // جلوگیری از ارسال‌های تکراری و نزدیک به هم
        if (Math.abs(time - lastSentTimeRef.current) < 5) {
            return;
        }

        try {
            isSendingRef.current = true;
            await axiosInstance.post(endpoint, {
                media_id: id, 
                // بک‌اند منتظر 'position_sec' است
                position_sec: Math.floor(time),
                duration: Math.round(time) + 60,
                is_finished: false
            });
            lastSentTimeRef.current = time;
            // console.log(`[HEARTBEAT] Saved position: ${Math.floor(time)}s`);
        } catch (error) {
             console.error("Error saving playback history:", error);
        } finally {
            isSendingRef.current = false;
        }
    }, [isLoggedIn]); 

    // ----------------------------------------------------
    // ج. تایمر Heartbeat
    // ----------------------------------------------------
    useEffect(() => {
        let intervalId;

        if (isPlaying && mediaId && isLoggedIn) {
            intervalId = setInterval(() => {
                savePlaybackPosition(mediaId, currentTime);
            }, HEARTBEAT_INTERVAL);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
            // ذخیره نهایی در زمان خروج (Cleanup)
            if (mediaId && currentTime > 0 && isLoggedIn) {
                savePlaybackPosition(mediaId, currentTime);
            }
        };
    }, [mediaId, isPlaying, savePlaybackPosition, isLoggedIn, currentTime]); 

    // ----------------------------------------------------
    // د. تابع واکشی موقعیت اولیه (برای از سرگیری)
    // ----------------------------------------------------
    const getInitialPlaybackPosition = useCallback(async () => {
        if (!mediaId || !isLoggedIn) return 0;
        
        // ✅ FIX: تغییر مسیر به products و استفاده از Query Param
        const endpoint = `/products/user/history/?media_id=${mediaId}`; 
        
        try {
             const response = await axiosInstance.get(endpoint);
             // 💡 سریالایزر 'last_position_sec' برمی‌گرداند
             const savedPosition = response.data?.results?.[0]?.last_position_sec || 0; 
             return savedPosition;
        } catch (error) {
             return 0; 
        }
    }, [mediaId, isLoggedIn]);


    return { getInitialPlaybackPosition, trackView };
}